export default "__VITE_ASSET__RoyeJRMl__"